import Header from "./components/Header"
import TripPlanner from "./components/TripPlanner"
import "./App.css"

function App() {
  return (
    <div className="App">
      <Header />
      <main className="container mx-auto p-0 sm:p-4 md:p-8 py-2">
        <TripPlanner />
      </main>
    </div>
  )
}

export default App
